import { RouteComponentProps, withRouter } from "react-router";
import { OBJECT_TYPE } from "common/constants";
import {
  AccountDocumentType,
  useDeleteDocumentUploadMutation,
} from "../../generated/graphql";
import { useStatusToasts } from "../../hooks/useStatusToasts";
import { CAROUSEL_DOCUMENTS_QUERY } from "../Common/Carousel/__queries__/getCarouselDocuments";
import { CommonModal } from "../Common/CommonModal";
import { getDefaultDeleteBody } from "../Common/DeleteModal";

export interface DeleteConfirmationProps extends RouteComponentProps<
  {},
  {},
  { prevLocation?: string; forceRefresh?: boolean }
> {
  isDetailView: boolean;
  documentUploadId: string;
  accountDocumentType: Pick<AccountDocumentType, "name">;
  closeModal: () => void;
  onUpdate?: () => void;
  objectId: Maybe<string>;
  objectType: Maybe<OBJECT_TYPE>;
}

export const DeleteDocumentUploadConfirmation = withRouter(
  ({
    isDetailView,
    documentUploadId,
    accountDocumentType,
    closeModal,
    history,
    onUpdate,
    location,
    objectId,
    objectType,
  }: DeleteConfirmationProps) => {
    const { addSuccessToast, addErrorToast } = useStatusToasts();

    const refetchQueries =
      objectId && objectType
        ? [
            {
              query: CAROUSEL_DOCUMENTS_QUERY,
              variables: {
                objectId,
                objectType,
              },
            },
          ]
        : [];

    const [deleteDocumentUpload, { loading }] = useDeleteDocumentUploadMutation(
      {
        onCompleted: () => {
          onUpdate?.();
          closeModal();
          if (isDetailView) {
            const newPath = location.state?.prevLocation ?? "/";
            history.push(newPath, { forceRefresh: true });
          }
          addSuccessToast("Your file was successfully deleted");
        },
        onError: () => {
          closeModal();
          addErrorToast(
            "There was an issue deleting this file. Please try again. If the problem persists, please email us at support@withforerunner.com",
          );
        },
        refetchQueries,
      },
    );

    return (
      <CommonModal
        title="Delete file"
        subtitle={accountDocumentType.name}
        content={getDefaultDeleteBody("file")}
        onCancel={closeModal}
        onSubmit={async () => {
          await deleteDocumentUpload({
            variables: { documentUploadId },
          });
        }}
        loading={loading}
        size="small"
        primaryButtonText="Delete"
        variant="destructive"
      />
    );
  },
);
